
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */

import DocsBeta from 'src/components/docs/DocsBeta/index.tsx';

export const metadata = {
  toc: true,
  layout: 'guide',
  source: 'error',
  description: 'Guide to understanding and troubleshooting errors specific to the Virtual Account product.',
  title: 'Virtual Account (UK/EU) errors'
};
const makeShortcode = name => function MDXDefaultShortcode(props) {
      console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope")
      return <div {...props}/>
    };
const Header = makeShortcode("Header");
const ErrorReference = makeShortcode("ErrorReference");
const Checkbox = makeShortcode("Checkbox");
const layoutProps = {
  metadata
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <Header title='Virtual Account (UK/EU) errors' subtitle={metadata.description} mdxType="Header" />
    <h4 {...{
      "id": "transaction_insufficient_funds"
    }}><strong parentName="h4">{`TRANSACTION_INSUFFICIENT_FUNDS`}</strong></h4>
    <ErrorReference type='VIRTUAL_ACCOUNTS_ERROR' error='TRANSACTION_INSUFFICIENT_FUNDS' subtitle='The transaction was declined due to insufficient funds in the account.' server mdxType="ErrorReference">
      <h5 {...{
        "id": "common-causes"
      }}>{`Common causes`}</h5>
      <ul>
        <li parentName="ul">{`The account does not have sufficient funds to complete the transaction.`}</li>
      </ul>
      <h5 {...{
        "id": "troubleshooting-steps"
      }}>{`Troubleshooting steps`}</h5>
      <Checkbox mdxType="Checkbox">
        <p>{`Check the `}<a parentName="p" {...{
            "href": "/docs/api/products/virtual-accounts/#wallet-list-response-wallets-balance-available"
          }}>{`available balance`}</a>{` on the Virtual Account.`}</p>
      </Checkbox>
      <Checkbox mdxType="Checkbox">
        <p>{`If the Virtual Account has insufficient balance, `}<a parentName="p" {...{
            "href": "/docs/payment-initiation/virtual-accounts/managing-virtual-accounts/#fund-your-virtual-account"
          }}>{`fund the Virtual Account`}</a>{` and try again.`}</p>
      </Checkbox>
      <Checkbox mdxType="Checkbox">
        <p>{`Try again with a lower `}<a parentName="p" {...{
            "href": "/docs/api/products/virtual-accounts/#wallet-transaction-execute-request-amount"
          }}>{`transaction amount`}</a>{`.`}</p>
      </Checkbox>
    </ErrorReference>
    <h4 {...{
      "id": "transaction_amount_exceeded"
    }}><strong parentName="h4">{`TRANSACTION_AMOUNT_EXCEEDED`}</strong></h4>
    <ErrorReference type='VIRTUAL_ACCOUNTS_ERROR' error='TRANSACTION_AMOUNT_EXCEEDED' subtitle='The transaction was declined due to the amount exceeding the allowed threshold' server mdxType="ErrorReference">
      <h5 {...{
        "id": "common-causes-1"
      }}>{`Common causes`}</h5>
      <ul>
        <li parentName="ul">{`The transaction amount exceeds the allowed threshold configured for this client.`}</li>
      </ul>
      <h5 {...{
        "id": "troubleshooting-steps-1"
      }}>{`Troubleshooting steps`}</h5>
      <Checkbox mdxType="Checkbox">
        <p>{`Contact your Plaid account manager for your compliance rules.`}</p>
      </Checkbox>
    </ErrorReference>
    <h4 {...{
      "id": "transaction_on_same_account"
    }}><strong parentName="h4">{`TRANSACTION_ON_SAME_ACCOUNT`}</strong></h4>
    <ErrorReference type='VIRTUAL_ACCOUNTS_ERROR' error='TRANSACTION_ON_SAME_ACCOUNT' subtitle='The transaction was attempted into the same account and declined.' server mdxType="ErrorReference">
      <h5 {...{
        "id": "common-causes-2"
      }}>{`Common causes`}</h5>
      <ul>
        <li parentName="ul">{`The recipient bank account details on the transaction are incorrect and refer to the source Virtual Account.`}</li>
      </ul>
      <h5 {...{
        "id": "troubleshooting-steps-2"
      }}>{`Troubleshooting steps`}</h5>
      <Checkbox mdxType="Checkbox">
        <p>{`Confirm that the `}<a parentName="p" {...{
            "href": "/docs/api/products/virtual-accounts/#wallet-transaction-execute-request-counterparty"
          }}>{`bank account details`}</a>{` do not route back to the Virtual Account.`}</p>
      </Checkbox>
      <Checkbox mdxType="Checkbox">
        <p>{`Try again with a different recipient bank account.`}</p>
      </Checkbox>
    </ErrorReference>
    <h4 {...{
      "id": "transaction_currency_mismatch"
    }}><strong parentName="h4">{`TRANSACTION_CURRENCY_MISMATCH`}</strong></h4>
    <ErrorReference type='VIRTUAL_ACCOUNTS_ERROR' error='TRANSACTION_CURRENCY_MISMATCH' subtitle='The transaction was declined due to a currency mismatch.' server mdxType="ErrorReference">
      <h5 {...{
        "id": "common-causes-3"
      }}>{`Common causes`}</h5>
      <ul>
        <li parentName="ul">{`The currency on the recipient bank account is different than that of the wallet.`}</li>
      </ul>
      <h5 {...{
        "id": "troubleshooting-steps-3"
      }}>{`Troubleshooting steps`}</h5>
      <Checkbox mdxType="Checkbox">
        <p>{`Check the `}<a parentName="p" {...{
            "href": "/docs/api/products/virtual-accounts/#wallet-get-response-balance-iso-currency-code"
          }}>{`currency`}</a>{` of the Virtual Account`}</p>
      </Checkbox>
      <Checkbox mdxType="Checkbox">
        <p>{`Confirm that the provided `}<a parentName="p" {...{
            "href": "/docs/api/products/virtual-accounts/#wallet-transaction-execute-request-counterparty"
          }}>{`bank account details`}</a>{` accepts the same currency as the Virtual Account.`}</p>
      </Checkbox>
      <Checkbox mdxType="Checkbox">
        <p>{`Try again with a different recipient bank account.`}</p>
      </Checkbox>
    </ErrorReference>
    <h4 {...{
      "id": "transaction_iban_invalid"
    }}><strong parentName="h4">{`TRANSACTION_IBAN_INVALID`}</strong></h4>
    <ErrorReference type='VIRTUAL_ACCOUNTS_ERROR' error='TRANSACTION_IBAN_INVALID' subtitle='The transaction was declined due to an invalid IBAN.' server mdxType="ErrorReference">
      <h5 {...{
        "id": "common-causes-4"
      }}>{`Common causes`}</h5>
      <ul>
        <li parentName="ul">{`The provided IBAN on the recipient bank account is invalid.`}</li>
      </ul>
      <h5 {...{
        "id": "troubleshooting-steps-4"
      }}>{`Troubleshooting steps`}</h5>
      <Checkbox mdxType="Checkbox">
        <p>{`Check that a valid `}<a parentName="p" {...{
            "href": "/docs/api/products/virtual-accounts/#wallet-transaction-execute-request-counterparty-numbers-international-iban"
          }}>{`IBAN`}</a>{` was provided in the request.`}</p>
      </Checkbox>
    </ErrorReference>
    <h4 {...{
      "id": "transaction_bacs_invalid"
    }}><strong parentName="h4">{`TRANSACTION_BACS_INVALID`}</strong></h4>
    <ErrorReference type='VIRTUAL_ACCOUNTS_ERROR' error='TRANSACTION_BACS_INVALID' subtitle='The transaction was declined due to an invalid Bacs account number and/or sort code.' server mdxType="ErrorReference">
      <h5 {...{
        "id": "common-causes-5"
      }}>{`Common causes`}</h5>
      <ul>
        <li parentName="ul">{`The provided Account Number and/or Sort Code on the recipient account is invalid.`}</li>
      </ul>
      <h5 {...{
        "id": "troubleshooting-steps-5"
      }}>{`Troubleshooting steps`}</h5>
      <Checkbox mdxType="Checkbox">
        <p>{`Check that a valid `}<a parentName="p" {...{
            "href": "/docs/api/products/virtual-accounts/#wallet-transaction-execute-request-counterparty-numbers-bacs-account"
          }}>{`Account Number`}</a>{` was provided in the request.`}</p>
      </Checkbox>
      <Checkbox mdxType="Checkbox">
        <p>{`Check that a valid `}<a parentName="p" {...{
            "href": "/docs/api/products/virtual-accounts/#wallet-transaction-execute-request-counterparty-numbers-bacs-sort-code"
          }}>{`Sort Code`}</a>{` was provided in the request.`}</p>
      </Checkbox>
    </ErrorReference>
    <h4 {...{
      "id": "transaction_fast_pay_disabled"
    }}><strong parentName="h4">{`TRANSACTION_FAST_PAY_DISABLED`}</strong></h4>
    <ErrorReference type='VIRTUAL_ACCOUNTS_ERROR' error='TRANSACTION_FAST_PAY_DISABLED' subtitle='The transaction was declined due to the recipient sort code not being enabled for Faster Payments ' server mdxType="ErrorReference">
      <h5 {...{
        "id": "common-causes-6"
      }}>{`Common causes`}</h5>
      <ul>
        <li parentName="ul">{`The provided Sort Code on the recipient account is not enabled for Faster Payments. GBP transactions out of Virtual Accounts in GB are made via the Faster Payments rail.`}</li>
      </ul>
      <h5 {...{
        "id": "troubleshooting-steps-6"
      }}>{`Troubleshooting steps`}</h5>
      <Checkbox mdxType="Checkbox">
        <p>{`Check with the bank of the recipient bank account that Faster Payments has been enabled.`}</p>
      </Checkbox>
      <Checkbox mdxType="Checkbox">
        <p>{`Try again using a different recipient bank account if Faster Payments is not supported.`}</p>
      </Checkbox>
    </ErrorReference>
    <h4 {...{
      "id": "transaction_execution_failed"
    }}><strong parentName="h4">{`TRANSACTION_EXECUTION_FAILED`}</strong></h4>
    <ErrorReference type='VIRTUAL_ACCOUNTS_ERROR' error='TRANSACTION_EXECUTION_FAILED' subtitle='The transaction failed to execute.' server mdxType="ErrorReference">
      <h5 {...{
        "id": "common-causes-7"
      }}>{`Common causes`}</h5>
      <ul>
        <li parentName="ul">{`The transaction failed to execute due to an internal error.`}</li>
        <li parentName="ul">{`The transaction might have been declined by the receiving bank.`}</li>
        <li parentName="ul">{`Technical issues with the payment processor.`}</li>
      </ul>
      <h5 {...{
        "id": "troubleshooting-steps-7"
      }}>{`Troubleshooting steps`}</h5>
      <Checkbox mdxType="Checkbox">
        <p>{`Check the request body against the API reference for `}<inlineCode parentName="p">{`/wallet/transaction/execute`}</inlineCode></p>
      </Checkbox>
    </ErrorReference>
    <h4 {...{
      "id": "nonidentical_request"
    }}><strong parentName="h4">{`NONIDENTICAL_REQUEST`}</strong></h4>
    <ErrorReference type='VIRTUAL_ACCOUNTS_ERROR' error='NONIDENTICAL_REQUEST' subtitle='The request is not identical to the original request.' server mdxType="ErrorReference">
      <h5 {...{
        "id": "common-causes-8"
      }}>{`Common causes`}</h5>
      <ul>
        <li parentName="ul">{`The request parameters have changed compared to the original request with the same idempotency key.`}</li>
      </ul>
      <h5 {...{
        "id": "troubleshooting-steps-8"
      }}>{`Troubleshooting steps`}</h5>
      <Checkbox mdxType="Checkbox">
        <p>{`Check that `}<a parentName="p" {...{
            "href": "/docs/payment-initiation/virtual-accounts/managing-virtual-accounts/#idempotency"
          }}>{`idempotency keys`}</a>{` are not being reused for different requests.`}</p>
      </Checkbox>
    </ErrorReference>
    <h4 {...{
      "id": "request_conflict"
    }}><strong parentName="h4">{`REQUEST_CONFLICT`}</strong></h4>
    <ErrorReference type='VIRTUAL_ACCOUNTS_ERROR' error='REQUEST_CONFLICT' subtitle='Original request is still processing.' server mdxType="ErrorReference">
      <h5 {...{
        "id": "common-causes-9"
      }}>{`Common causes`}</h5>
      <ul>
        <li parentName="ul">{`The original request is still processing and has not completed.`}</li>
        <li parentName="ul">{`A network or system issue caused a delay in processing the original request, resulting in a conflict when the new request is sent.`}</li>
      </ul>
      <h5 {...{
        "id": "troubleshooting-steps-9"
      }}>{`Troubleshooting steps`}</h5>
      <Checkbox mdxType="Checkbox">
        <p>{`Wait and retry the request again`}</p>
      </Checkbox>
    </ErrorReference>
    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;

            export const tableOfContents = [
      {
        id: "transaction_insufficient_funds",
        level: 4,
        title: "TRANSACTION_INSUFFICIENT_FUNDS",
      },
{
        id: "transaction_amount_exceeded",
        level: 4,
        title: "TRANSACTION_AMOUNT_EXCEEDED",
      },
{
        id: "transaction_on_same_account",
        level: 4,
        title: "TRANSACTION_ON_SAME_ACCOUNT",
      },
{
        id: "transaction_currency_mismatch",
        level: 4,
        title: "TRANSACTION_CURRENCY_MISMATCH",
      },
{
        id: "transaction_iban_invalid",
        level: 4,
        title: "TRANSACTION_IBAN_INVALID",
      },
{
        id: "transaction_bacs_invalid",
        level: 4,
        title: "TRANSACTION_BACS_INVALID",
      },
{
        id: "transaction_fast_pay_disabled",
        level: 4,
        title: "TRANSACTION_FAST_PAY_DISABLED",
      },
{
        id: "transaction_execution_failed",
        level: 4,
        title: "TRANSACTION_EXECUTION_FAILED",
      },
{
        id: "nonidentical_request",
        level: 4,
        title: "NONIDENTICAL_REQUEST",
      },
{
        id: "request_conflict",
        level: 4,
        title: "REQUEST_CONFLICT",
      }
];
          
layoutProps.tableOfContents = tableOfContents;
MDXContent.layoutProps = layoutProps;

MDXContent.layout = function (props) { return <DocsBeta {...props} /> };
